import { Link } from 'react-router-dom';
import SectionHeading from '@/components/feature/SectionHeading';
import { stories } from '@/mocks/stories';

export default function RankingSection() {
  const ranked = [...stories].sort((a, b) => b.views - a.views).slice(0, 6);
  const maxViews = ranked[0]?.views ?? 1;

  return (
    <section className="bg-foreground-950 py-14 text-background-100 md:py-20">
      <div className="mx-auto grid w-full max-w-content grid-cols-1 gap-12 px-4 md:px-6 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/20 px-3 py-1 text-xs font-medium text-background-200">
            <i className="ri-line-chart-line" />
            本周话题热度
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold text-background-50 md:text-3xl">
            大家在围观什么
          </h2>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
            热度来自文章阅读量、收藏与读者转发的综合计算，每周更新一次。排行会有所起伏，
            但有些校园话题总是能反复回到榜上，比如宿舍关系、点名和食堂。
          </p>
          <Link
            to="/stories"
            className="mt-7 inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
          >
            看看完整榜单 <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="lg:col-span-7">
          <ul className="space-y-5">
            {ranked.map((story, i) => {
              const percent = Math.round((story.views / maxViews) * 100);
              return (
                <li key={story.id}>
                  <Link to={`/stories/${story.id}`} className="group block">
                    <div className="flex items-center gap-3">
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                          i < 3 ? 'bg-primary-500 text-background-50' : 'bg-background-50/10 text-background-200'
                        }`}
                      >
                        {i + 1}
                      </span>
                      <span className="flex-1 truncate text-sm font-medium text-background-100 transition-colors group-hover:text-accent-300">
                        #{story.tags[0]}
                      </span>
                      <span className="shrink-0 text-xs text-background-400">
                        {(story.views / 10000).toFixed(1)}w
                      </span>
                    </div>
                    <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-background-50/10">
                      <div
                        className={`h-full rounded-full ${i < 3 ? 'bg-primary-500' : 'bg-accent-500/70'}`}
                        style={{ width: `${percent}%` }}
                      />
                    </div>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
}